import { observer } from "mobx-react-lite";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import RoadDetailViewModel from "viewModels/timeCharges/distributorEnums/roads/roadDetailViewModel";
import EditableDetailView from "views/common/editableDetailView";
import RoadForm from "./roadForm";

const RoadDetailView: ViewComponent<RoadDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<RoadForm vm={vm} />} />;
});

registerView(RoadDetailView, RoadDetailViewModel);
